import type {
	createListedPlayerInput,
	getListedPlayerInput,
	getListedPlayersSchemaQuery,
	updateListedPlayerInfoInput,
	verifyListedPlayerStatusInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetListedPlayers: getListedPlayersSchemaQuery;
	useCreateListedPlayer: createListedPlayerInput;
	useGetListedPlayer: getListedPlayerInput;
	useVerifyListedPlayerStatus: verifyListedPlayerStatusInput;
	useUpdateListedPlayerInfo: updateListedPlayerInfoInput;
}

const LISTED_PLAYERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"listed-players",
	[
		"useGetListedPlayers",
		"useCreateListedPlayer",
		"useGetListedPlayer",
		"useVerifyListedPlayerStatus",
		"useUpdateListedPlayerInfo",
	],
);

export { LISTED_PLAYERS_SERVICE_KEYS };
